// pages/FormViewerPage/hooks/useFormViewer/submitConfirmation.ts — WhatsApp confirmation + notifications
import { supabase } from '../../../../supabase/client';
import type { Form } from '../../../../types';
import { getWhatsAppNumberForOrder } from '../../../../utils/whatsappHelper';
import { logWhatsAppMessage } from '../../../../utils/whatsappLogHelper';

export async function sendOrderConfirmations(params: {
    orderData: any;
    form: Form | null;
    brandId: string;
    assignedCsId: string | undefined;
    phone: string;
    name: string;
    productName: string;
    totalPrice: number;
    addressText: string;
    province: string;
    city: string;
    district: string;
    village: string;
    sendOrderConfirmation: any;
}) {
    const {
        orderData, form, brandId, assignedCsId, phone, name, productName, totalPrice,
        addressText, province, city, district, village, sendOrderConfirmation,
    } = params;

    try {
        const waNum = await getWhatsAppNumberForOrder(brandId, assignedCsId, 'physical_form');
        if (waNum) {
            const waResult = await sendOrderConfirmation(phone, {
                orderId: orderData.id, customerName: name, productName, totalPrice,
                shippingAddress: addressText, province, city, district, village, postalCode: '',
            }, { device: waNum.device, customApiKey: waNum.apiKey } as any);
            await logWhatsAppMessage({ orderId: orderData.id, phoneNumber: phone, messageType: 'order_confirmation', status: waResult.status ? 'sent' : 'failed', messagePreview: `${name} - ${productName}`, messageContent: '', customerName: name });
            if (assignedCsId) {
                // RPC update_public_order (whitelist kolom) — tabel orders TIDAK bisa
                // di-UPDATE langsung oleh anon lagi (policy anon-UPDATE sudah dicabut).
                // FIX 2026-08-17 (warna status WA): GAGAL KIRIM ≠ nomor tidak aktif.
                // Jangan tulis 'inactive' dari hasil kirim — biarkan waChecker (Baileys)
                // yang memvalidasi sungguhan; hanya sukses kirim yang menandakan aktif.
                Promise.resolve(supabase.rpc('update_public_order', {
                    p_order_id: orderData.id,
                    p_patch: waResult.status
                        ? { whatsapp_welcome_status: 'sent', whatsapp_number_status: 'active' }
                        : { whatsapp_welcome_status: 'failed' },
                })).catch(() => {});
            }
        }
    } catch { /* status WA gagal tercatat di whatsapp_logs via logWhatsAppMessage */ }
    try {
        await supabase.rpc('create_order_notifications', {
            p_order_id: orderData.id,
            p_brand_id: brandId,
            p_form_id: form?.id,
            p_assigned_cs_id: assignedCsId || null,
            p_advertiser_id: form?.assignedAdvertiserId || null,
            p_customer_name: name,
            p_product_name: productName,
            p_order_no: orderData.order_no ?? null,
        });
    } catch { /* */ }
}
